<template>
  <g>
    <circle cx="20" cy="20" r="20" :fill="bgColor" />
    <path
      d="M19.7869 23.1287L17.3577 20.3945C17.1412 20.1501 16.7666 20.1282 16.5223 20.3454C16.278 20.5627 16.256 20.9364 16.4733 21.1807C16.4733 21.1807 16.4733 21.1808 16.4733 21.1808L19.3472 24.4146L19.7869 23.1287ZM19.7869 23.1287L24.7885 17.4456C24.7886 17.4456 24.7886 17.4456 24.7886 17.4456C25.0042 17.2003 25.3787 17.1767 25.6239 17.3923C25.8691 17.6079 25.8927 17.9824 25.6772 18.2276L25.6771 18.2276L20.2333 24.4129L20.2333 24.413C20.1209 24.5406 19.9603 24.6133 19.7905 24.6141L19.7402 24.6144V24.6113C19.5895 24.5988 19.4487 24.5291 19.3473 24.4147L19.7869 23.1287ZM19.7402 24.5641V24.5645C19.7402 24.5644 19.7402 24.5643 19.7402 24.5642C19.7402 24.5637 19.7402 24.5636 19.7402 24.5641Z"
      :fill="iconColor"
      :stroke="iconColor"
      stroke-width="0.1"
    />
    <path
      d="M19.8848 8.90109C19.8848 9.22825 20.1495 9.49291 20.4766 9.49291C20.8039 9.49291 21.0685 9.22743 21.0685 8.90109V6.54183C21.0685 6.21466 20.8038 5.95 20.4766 5.95C20.1495 5.95 19.8848 6.21466 19.8848 6.54183V8.90109Z"
      :fill="iconColor"
      :stroke="iconColor"
      stroke-width="0.1"
    />
    <path
      d="M26.9534 11.8899C27.0692 12.0057 27.2207 12.0632 27.3719 12.0632C27.5231 12.0632 27.6746 12.0057 27.7904 11.8899L29.4584 10.2219C29.6893 9.99102 29.6893 9.61569 29.4584 9.38485C29.2276 9.15401 28.8523 9.15401 28.6214 9.38485L26.9534 11.0529C26.7226 11.2837 26.7226 11.6591 26.9534 11.8899Z"
      :fill="iconColor"
      :stroke="iconColor"
      stroke-width="0.1"
    />
    <path
      d="M30.5709 19.5838H32.9302C33.2574 19.5838 33.522 19.3192 33.522 18.992C33.522 18.6649 33.2574 18.4002 32.9302 18.4002H30.5709C30.2438 18.4002 29.9791 18.6649 29.9791 18.992C29.9791 19.3192 30.2438 19.5838 30.5709 19.5838Z"
      :fill="iconColor"
      :stroke="iconColor"
      stroke-width="0.1"
    />
    <path
      d="M28.2808 28.2161C28.3966 28.3319 28.5481 28.3894 28.6993 28.3894C28.8505 28.3894 29.002 28.3319 29.1178 28.2161C29.3486 27.9852 29.3486 27.6099 29.1178 27.3791L27.4498 25.711C27.2189 25.4802 26.8436 25.4802 26.6128 25.711C26.3819 25.9419 26.3819 26.3172 26.6128 26.548L28.2808 28.2161Z"
      :fill="iconColor"
      :stroke="iconColor"
      stroke-width="0.1"
    />
    <path
      d="M13.859 11.89L13.8591 11.8899C14.09 11.6591 14.09 11.2837 13.8591 11.0529L12.1911 9.38485C11.9603 9.15401 11.5849 9.15401 11.3541 9.38485C11.1232 9.61569 11.1232 9.99102 11.3541 10.2219L13.0221 11.8899C13.1379 12.0057 13.2894 12.0632 13.4406 12.0632C13.592 12.0632 13.7434 12.0048 13.859 11.89Z"
      :fill="iconColor"
      :stroke="iconColor"
      stroke-width="0.1"
    />
    <path
      d="M7.54183 19.1024H9.90109C10.2274 19.1024 10.4929 18.8378 10.4929 18.5106C10.4929 18.1834 10.2283 17.9187 9.90109 17.9187H7.54183C7.21466 17.9187 6.95 18.1834 6.95 18.5106C6.95 18.8377 7.21466 19.1024 7.54183 19.1024Z"
      :fill="iconColor"
      :stroke="iconColor"
      stroke-width="0.1"
    />
    <path
      d="M11.0136 28.2161C11.1294 28.3319 11.2809 28.3894 11.4321 28.3894C11.5834 28.3894 11.7348 28.3319 11.8506 28.2161L13.5187 26.548C13.7495 26.3172 13.7495 25.9419 13.5187 25.711C13.2878 25.4802 12.9125 25.4802 12.6817 25.711L11.0136 27.3791C10.7828 27.6099 10.7828 27.9852 11.0136 28.2161Z"
      :fill="iconColor"
      :stroke="iconColor"
      stroke-width="0.1"
    />
    <path
      d="M16.7738 28.503C16.4905 28.503 16.2521 28.2832 16.2335 27.996C16.1066 26.0385 15.3991 25.4904 14.5043 24.7969C13.3556 23.9068 12.0529 22.8974 11.8083 19.1704C11.6829 17.264 12.3765 15.4009 13.7605 13.9225C15.3945 12.1778 17.7537 11.1777 20.2345 11.1777C22.7292 11.1777 25.0993 12.1855 26.7356 13.9426C28.1119 15.4195 28.7953 17.2771 28.6607 19.1728C28.4037 22.7921 27.1443 23.7945 26.0336 24.68C25.3896 25.1932 24.833 25.6367 24.4948 26.6081C24.3965 26.8907 24.0876 27.0401 23.8051 26.9418C23.5226 26.8435 23.3732 26.5346 23.4715 26.2521C23.9127 24.9842 24.6473 24.399 25.3586 23.8325C26.3865 23.0135 27.3572 22.241 27.5801 19.0961C27.6931 17.5039 27.1118 15.9357 25.943 14.681C24.5312 13.1655 22.3979 12.2614 20.2345 12.2614C18.0842 12.2614 15.9603 13.1593 14.5515 14.6632C13.3742 15.9203 12.7844 17.4954 12.8897 19.0992C13.1025 22.3393 14.1057 23.1165 15.1677 23.94C16.1445 24.6971 17.1554 25.4804 17.3141 27.9248C17.3334 28.2236 17.1074 28.4813 16.8086 28.5007C16.7978 28.5022 16.7854 28.503 16.7738 28.503Z"
      :fill="iconColor"
    />
    <path
      d="M16.6825 32.7671C16.4232 32.7671 16.1941 32.5805 16.1492 32.3166C16.0989 32.0217 16.297 31.7415 16.5919 31.6912L23.6983 30.4736C23.9932 30.4233 24.2734 30.6215 24.3238 30.9164C24.3741 31.2113 24.1759 31.4915 23.881 31.5418L16.7746 32.7593C16.7436 32.764 16.7127 32.7671 16.6825 32.7671Z"
      :fill="iconColor"
    />
    <path
      d="M16.6825 30.7075C16.4232 30.7075 16.1941 30.521 16.1492 30.257C16.0989 29.9621 16.297 29.6819 16.5919 29.6316L23.6983 28.4141C23.9932 28.3637 24.2734 28.5619 24.3238 28.8568C24.3741 29.1517 24.1759 29.4319 23.881 29.4822L16.7746 30.6998C16.7436 30.7044 16.7127 30.7075 16.6825 30.7075Z"
      :fill="iconColor"
    />
    <path
      d="M16.6825 28.647C16.4232 28.647 16.1941 28.4604 16.1492 28.1965C16.0989 27.9016 16.297 27.6214 16.5919 27.5711L23.6983 26.3535C23.9932 26.3032 24.2734 26.5013 24.3238 26.7963C24.3741 27.0912 24.1759 27.3714 23.881 27.4217L16.7746 28.6392C16.7436 28.6439 16.7127 28.647 16.6825 28.647Z"
      :fill="iconColor"
    />
    <path
      d="M20.1616 34C20.0502 34 19.9379 33.9954 19.8257 33.9853C18.821 33.8994 17.9224 33.4311 17.4216 32.7321C17.2474 32.4891 17.3031 32.1501 17.5462 31.9759C17.7892 31.8017 18.1283 31.8575 18.3024 32.1005C18.6213 32.5456 19.2251 32.8467 19.9178 32.9055C21.003 32.9976 21.9876 32.4473 22.0712 31.7034C22.1045 31.4062 22.3723 31.1918 22.6703 31.2251C22.9675 31.2584 23.1819 31.527 23.1479 31.8242C23.072 32.4999 22.6657 33.0967 22.0031 33.5038C21.476 33.8282 20.832 34 20.1616 34Z"
      :fill="iconColor"
    />
    <path
      d="M16.6565 32.0552C16.6565 32.3823 16.9211 32.647 17.2483 32.647C17.5746 32.647 17.8401 32.3824 17.8401 32.0552V28.0379C17.8401 27.7108 17.5754 27.4461 17.2483 27.4461C16.9211 27.4461 16.6565 27.7108 16.6565 28.0379V32.0552Z"
      :fill="iconColor"
      :stroke="iconColor"
      stroke-width="0.1"
    />
    <path
      d="M22.6319 31.0029C22.6319 31.3301 22.8966 31.5947 23.2237 31.5947C23.5509 31.5947 23.8156 31.3301 23.8156 31.0029V27.0174C23.8156 26.6902 23.5509 26.4256 23.2237 26.4256C22.8966 26.4256 22.6319 26.6902 22.6319 27.0174V31.0029Z"
      :fill="iconColor"
      :stroke="iconColor"
      stroke-width="0.1"
    />
  </g>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
@Options({
  props: {
    iconColor: { type: String, default: "#ffffff" },
    bgColor: { type: String, default: "#ee1c25" }
  }
})
export default class IconInvestedRoundedType7 extends Vue {
  iconColor!: string;
  bgColor!: string;
}
</script>
